import { Link } from "gatsby"
import { default as React } from "react"
import {
	connectStateResults,
	Hits,
	Index, InstantSearch, Pagination, Configure
} from "react-instantsearch-dom"
import { getCategoryById } from "../../utils/categoriesUtils"

const HitCount = connectStateResults(({ searchResults }) => {
	const hitCount = searchResults && searchResults.nbHits

	console.log(searchResults)

	return hitCount > 0 ? (
		<div className="HitCount">
			{hitCount} recette{hitCount !== 1 ? `s` : ``}
		</div>
	) : null
})

const PageHit = ({ hit }) => (
	<a target="_blank" href={hit.share_url}>
		<div className="image" style={{backgroundImage : `url(${hit.web_cover_thumbnail})`}}/>
		<div>
			<h4>
				{hit.title}
			</h4>
			<p>
				{hit.subtitle}
			</p>
		</div>
	</a>
)

const HitsInIndex = ({ index }) => (
	<Index indexName={index.name}>
		<Configure
			filters="language:fr"
			hitsPerPage={9}
		/>
		<HitCount />
		<Hits className="Hits" hitComponent={PageHit} />
	</Index>
)

const SearchResult = ({ indices, className, category }) => {
	return (
		<div className={className}>
			<h2>{getCategoryById(category).name}{category ? ", l" : "L"}es recettes par ChefClub</h2>
			{indices.map(index => (
				<HitsInIndex index={index} key={index.name}/>
			))}
		</div>
	)
}

export default SearchResult

export {
	HitCount,
	Hits,
}